commonModule.factory('authorizationService', ['$http', '$location', 'imSessionVarsService', 'identityMgmntService', function ($http, $location, imSessionVarsService, identityMgmntService) {

    var securityAPI = {};
        securityAPI.userHasRole = function (role) {
            var userRoles = imSessionVarsService.getCurrentIMUserRoles();
            for (var j = 0; j < userRoles.length; j++) {
                var userRole = userRoles[j].toUpperCase();
                userRole = userRole.replace(/ /g, '_');
                if (role == userRole) {
                    return true;
                }
            }
            return false;
        };

        securityAPI.isUrlAccessibleForUser = function (route) {
            //Retrieving the roles and privileges stored in session during log in
            var userRoleRouteMap = imSessionVarsService.getRolesAndPrivileges();
            var userRoles = imSessionVarsService.getCurrentIMUserRoles();
            if (userRoles && userRoleRouteMap) {
                for (var i = 0; i < userRoles.length; i++) {
                    var role = userRoles[i].toUpperCase();
                    role = role.replace(/ /g, '_');
                    var validUrlsForRole = userRoleRouteMap[role];
                    if (validUrlsForRole) {
                        for (var j = 0; j < validUrlsForRole.length; j++) {
                            if (validUrlsForRole[j] == route)
                                return true;
                        }
                    }
                }
            }
            return false;
        };

        securityAPI.isUIElementAccessibleForUser = function (element) {
            //Retrieving the roles and privileges stored in session during log in
            //var providerUIElements = JSON.parse(imSessionVarsService.getCurrentProviderUIRequiredAccess());
            var providerUIElements = JSON.parse((imSessionVarsService.getCurrentProviderSettings('UI-RequiredAccess')));
            var found =  _.find(providerUIElements, function(providerUIElement) {  return providerUIElement.Key == element; });
            if (found) {
                return found.Value;
            }
            return false;
        };

    return securityAPI;
}]);
